<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title>
          Formulario Número - {{ historicoId }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn dark text @click="dialogframeboton = !dialogframeboton"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Formulario Dinamico ¡-->
        <card-formulario
          :historicoId="historicoId"
          :formularioId="formularioId"
          :formdata="formdata"
          v-on:update:pageiframe="dialogframeboton = $event"
        >
        </card-formulario>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Tablero de control -->
  <div class="table-container">
    <v-data-table
      v-model:page="itemsPerPage"
      :headers="headers"
      :items="desserts"
      :search="search"
      item-value="Id"
      return-object
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- Filtros -->
          <v-dialog v-model="dialogframe" persistent max-width="1000px">
            <template v-slot:activator="{ props }">
              <v-btn
                color="cyan"
                icon="mdi-filter-menu"
                dark
                class="mb-2"
                v-bind="props"
              >
              </v-btn>
            </template>
            <v-card>
              <v-toolbar dark color="red-darken-4">
                <v-toolbar-title
                  ><v-icon left>mdi-filter-menu</v-icon> Filtros
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click="reset">Limpiar</v-btn>
                  <v-btn dark text @click="ValidateCampos">Consultar</v-btn>
                  <v-btn dark text @click="dialogframe = false">Cerrar</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" autocomplete="off">
                  <v-row v-for="(datos, i) in modelfiltro" :key="i">
                    <!-- Filtro -->
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="datos.filtro"
                        :items="items"
                        item-title="descripcion"
                        item-value="filtro"
                        label="Tipo de filtro:"
                        :clearable="datos.clear"
                        :readonly="datos.lectura"
                      ></v-autocomplete>
                    </v-col>
                    <!-- Contenido -->
                    <!-- Estado del Formulario  -->
                    <v-col v-if="i == 2" cols="6">
                      <v-autocomplete
                        v-model="datos.contenido"
                        :items="ArrayTipoNewContact"
                        :item-title="
                          (ArrayTipoNewContact) =>
                            ArrayTipoNewContact.Valor +
                            '-' +
                            ArrayTipoNewContact.Descripcion
                        "
                        item-value="Valor"
                        color="primary"
                        :label="datos.label"
                        dense
                        clearable
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                      >
                      </v-autocomplete>
                    </v-col>
                    <!--Responsable -->
                    <v-col v-else-if="i == 4" cols="6">
                      <v-autocomplete
                        v-model="datos.contenido"
                        :items="ArrayUser"
                        :item-title="
                          (ArrayUser) =>
                            ArrayUser.Usuario +
                            '-' +
                            ArrayUser.Nombre +
                            ' ' +
                            ArrayUser.Apellido
                        "
                        item-value="Usuario"
                        color="primary"
                        :label="datos.label"
                        dense
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                        :clearable="datos.clear"
                        :readonly="datos.lectura"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col v-else cols="6">
                      <v-text-field
                        v-model="datos.contenido"
                        :type="i == 1 ? 'date' : ''"
                        :label="datos.label"
                        :clearable="datos.clear"
                        :readonly="datos.lectura"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- Buscador -->
          <v-text-field
            v-model="search"
            append-inner-icon="mdi-magnify"
            label="Buscar..."
            single-line
            variant="underlined"
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <!-- Acciones  -->
      <template v-slot:item.actions="{ item }">
        <div class="text-left">
          <!-- Modificación o visualización -->
          <v-tooltip
            v-if="param1[0] == '1'"
            location="bottom"
            color="white"
          >
            <template v-slot:activator="{ props }">
              <v-icon
                color="indigo"
                @click="editItem(item.raw, 1)"
                v-bind="props"
                >{{
                  item.raw.EstadoFormulario != null ? "mdi-pencil" : "mdi-eye"
                }}</v-icon
              >
            </template>
            <span>{{
              item.raw.EstadoFormulario != null ? "Modificar" : "Consultar"
            }}</span>
          </v-tooltip>
          <v-divider  v-if="param1[0] == '1'" class="mx-1" inset vertical></v-divider>
          <!-- Extraer Archivo  -->
          <v-tooltip
            v-if="item.raw.EstadoFormulario == 3"
            location="bottom"
            color="white"
          >
            <template v-slot:activator="{ props }">
              <v-icon @click="editItem(item.raw, 2)" color="red" v-bind="props">
                mdi-download
              </v-icon>
            </template>
            <span> Extraer Archivo PDF </span>
          </v-tooltip>
                    <!-- Abrir nuevamente Formulario -->
                    <v-divider  v-if="param1[0] == '1'" class="mx-1" inset vertical></v-divider>
          <v-tooltip
              v-if="param1[0] == '1'"
            location="bottom"
            color="white"
          >
            <template v-slot:activator="{ props }">
              <v-icon @click="editItem(item.raw, 3)" color="green" v-bind="props">
                mdi-format-list-checks
              </v-icon>
            </template>
            <span> Habilitar Formulario </span>
          </v-tooltip>
        </div>
      </template>
      <!-- Estado  -->
      <template v-slot:item.EstadoFormulario="{ item }">
        <v-chip :color="item.raw.ColorEstadoFormulario" variant="flat">
          {{ item.raw.DescEstadoFormulario }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FormularioDinamico from "@/views/TCI/Formularios/FormularioDinamico/FormularioDinamico.vue";
export default {
  components: {
    "card-formulario": FormularioDinamico,
  },
  name: "ConsultaFormulariosHistorico",
  data() {
    return {
      itemsPerPage: 1,
      search: "",
      consult: false,
      respuestapostput: null,
      progreso: false,
      dialogframe: false,
      dialogframeboton: false,
      historicoId: 0,
      formularioId: 0,
      menubuttoms: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Id",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Id de Formulario Histórico:",
        },
        {
          campo: "FechaFinalDiligenciado",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha de diligenciamiento:",
        },
        {
          campo: "EstadoFormulario",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado Formulario:",
        },
        {
          campo: "FormularioId",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Nombre de Formulario:",
        },
        {
          campo: "UsuarioDiligencio",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Usuario Diligenciado:",
        },
        {
          campo: "ValorCampo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Valor:",
        },
      ],
      headers: [],
      desserts: [],
      param1: [],
      busquedacompleta: false,
      ArrayTipoNewContact: [],
      ArrayUser: [],
      formdata: [],
    };
  },
  computed: {},
  watch: {
    dialogframeboton(val) {
      if (!val) {
        console.log(val);
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
        parametro1: this.param1,
      };
      this.axios
        .post("/Formularios/FormularioDiligenciado/CT0/", data)
        .then((result) => {
          if (result.data.Status == 200) {
            this.headers = result.data.Data.Header;
            this.desserts = result.data.Data.Register;
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: result.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },

    // Consulta Exportar Archivo Formulario
    async getConsultDataExport(data) {
      this.progreso = true;
      this.axios
        .get(
          "/Formularios/Formulario/GetFormulariosExport?idForm=" +
            this.formularioId +
            "&idHistorico=" +
            this.historicoId
        )
        .then((response) => {
          if (response.data.Status == 200) {
            this.$swal({
              icon: "success",
              title: "¡Éxito!",
              html: response.data.Message,
            });
            // Crear un enlace de descarga para descargar el archivo
            const link = document.createElement("a");
            link.href = `${response.data.Data.ArchivoBase64}`;
            var name = "";
            if (data) {
              name = "Form" + data.Id;
              // Documento
              if (data.Document_ID) {
                name += "_" + data.Document_ID;
              }
              // Contrato
              if (data.Contrato) {
                name += "_" + data.Contrato;
              }
            } else {
              name = `${response.data.Data.NombreArchivo}`;
            }

            link.download = `${name}${response.data.Data.Formato}`; // El nombre del archivo con la extensión
            link.click(); // Dispara la descarga
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

        // Confirmación de eliminación
    ConfirmacionUpdateEstadoFormulario() {
        this.$swal({
          icon: "question",
          title: "Habiltar Formulario",
          html: "¿Está seguro que desea habilitar el formulario número"+this.historicoId+"?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateEstadoFormulario();
          }
        });

    },

    // Update Estado del Formulario
    async updateEstadoFormulario(data) {
      this.progreso = true;
      var userperfil = this.$store.getters.userperfil;
      var user = userperfil.userInfo.Usuario_ID;

      this.axios
        .get(
          "/Formularios/FormularioDiligenciado/UpdateFormulariosEstado?id=" +
            this.historicoId +
            "&estado=1" +
            "&usuario=" +
            user
        )
        .then((response) => {
          if (response.data.Status == 200) {
            this.$swal({
              icon: "success",
              title: "¡Éxito!",
              html: response.data.Message,
            });
            this.getConsultData();
          } else {
            this.$swal({
              icon: "warning",
              title: "Consulta inexistente.",
              html: response.data.Message,
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Item editar
    editItem(item, iconoelegido) {
      this.formularioId = item.FormularioId;
      this.historicoId = item.Id;
      this.formdata = item;
      switch (iconoelegido) {
        case 1: // Formularios
          this.dialogframeboton = true;
          break;
        case 2: // Exportar a PDF
          this.getConsultDataExport(item);
          break;
           case 3: // Abrir Formulario
          this.ConfirmacionUpdateEstadoFormulario(item);
          break; 
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
    },
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },
  },
  mounted() {
    this.ArrayTipoNewContact = this.$store.getters.MTablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 64
    );

    var User = this.$store.getters.MUsers;
    this.ArrayUser = User.filter((item) => item.Usuario.includes("TCI"));
    this.parametrospaginas();
  },
};
</script>
<style>
.table-container {
  overflow-x: auto; /* activa scroll horizontal */
  width: 100%;
}
</style>